import "./App.css";
import Layout from "./Common/Layout/Layout"; // Re-import Layout
import Home from "./Pages/Home";
import Integrations from "./Pages/Integrations/Index";
import Listing from "./Pages/Integrations/Listing";
import Overview from "./Pages/Integrations/Overview";
import Source from "./Pages/Integrations/Source";
import Destination from "./Pages/Integrations/Destination";
import DataMapping from "./Pages/Integrations/DataMapping";
import Review from "./Pages/Integrations/Review";
import Summary from "./Pages/Integrations/Summary";
import Details from "./Pages/Integrations/Details";
import Workflow from "@Pages/Integrations/Workflow";
import Invocations from "./Pages/Integrations/Invocations";
import Login from "./Pages/Login";
import Signup from "./Pages/Signup";
import EmailVerification from "./Pages/EmailVerification";
import { authService } from "./Common/services/httpClient";

import MembersList from "./Pages/MembersList";
import Settings from "./Pages/Settings";

import { Provider } from "react-redux";
import { store } from "./Redux/store";

import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";

// --- Authentication Logic ---
const isAuthenticated = () => {
  return authService.getAccessToken() !== null;
};

// --- Protected Route Component ---
const ProtectedRoute = ({ children }) => {
  if (!isAuthenticated()) {
    return <Navigate to="/login" replace />;
  }
  return children;
};

function App() {
  return (
    <Provider store={store}>
      <Router>
        <Routes>
          {/* Public Route - No Layout */}
          <Route path="/login" element={<Layout><Login /></Layout>} />
          {/* <Route path="/signup" element={<Layout><Signup /></Layout>} /> */}
          <Route path="/verify-email/:token" element={<EmailVerification />} />

          {/* Protected Routes - With Layout */}
          <Route
            path="/"
            element={
                  <Home />
            }
          />
          <Route
            path="/integrations"
            element={
              <ProtectedRoute>
                <Layout>
                  {" "}
                  {/* Apply Layout here */}
                  <Integrations />
                </Layout>{" "}
                {/* Close Layout here */}
              </ProtectedRoute>
            }
          >
            <Route
              index
              element={
                <ProtectedRoute>
                  <Layout>
                    <Listing />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="listing"
              element={
                <ProtectedRoute>
                  <Layout>
                    <Listing />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path=":id/overview"
              element={
                <ProtectedRoute>
                  <Layout>
                    <Overview />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path=":id/workflow"
              element={
                <ProtectedRoute>
                  <Layout>
                    <Workflow />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path=":id/source"
              element={
                <ProtectedRoute>
                  <Layout>
                    <Source />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path=":id/destination"
              element={
                <ProtectedRoute>
                  <Layout>
                    <Destination />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path=":id/data-mapping"
              element={
                <ProtectedRoute>
                  <Layout>
                    <DataMapping />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path=":id/review"
              element={
                <ProtectedRoute>
                  <Layout>
                    <Review />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path=":id/summary"
              element={
                <ProtectedRoute>
                  <Layout>
                    <Summary />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path=":id/details"
              element={
                <ProtectedRoute>
                  <Layout>
                    <Details />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path=":id/invocations"
              element={
                <ProtectedRoute>
                  <Layout>
                    <Invocations />
                  </Layout>
                </ProtectedRoute>
              }
            />
          </Route>
          {/* Catch-all route */}
          <Route path="*" element={<Navigate to="/" replace />} />
          <Route
            path="/memberslisting"
            element={
              <ProtectedRoute>
                <Layout>
                  <MembersList />
                </Layout>
              </ProtectedRoute>
            }
          />

          <Route
            path="/settings"
            element={
              <ProtectedRoute>
                <Layout>
                  <Settings />
                </Layout>
              </ProtectedRoute>
            }
          />
        </Routes>
      </Router>
    </Provider>
  );
}

export default App;
